// extracted by mini-css-extract-plugin
export var brand = "_9q-9";
export var compact = "_9q-6";
export var extraSmall = "_9q-7";
export var icon = "_9q-0";
export var large = "_9q-4";
export var light = "_9q-1";
export var medium = "_9q-5";
export var outline = "_9q-b";
export var primaryDark = "_9q-a";
export var primaryLight = "_9q-8";
export var primaryModern = "_9q-c";
export var success = "_9q-2";
export var successSolid = "_9q-3";